import { getDiscountCode } from "@/api/helper"
import { useState } from "react"
import { status as s } from "@/services/status"

type DiscountCodeProps = {
    aroeven: Aroeven,
    prestation: Bafad | HolidayStaySession,
    supplier: Aroeven,
    apply: Function,
    discountCodes: DiscountCode[]
}

export default function DiscountCode({
    aroeven,
    prestation,
    supplier,
    apply,
    discountCodes
}: DiscountCodeProps) {

    const [code, setCode] = useState('')
    const [status, setStatus] = useState(s.idle)
    const [error, setError] = useState('')

    return (
        <>
            <form onSubmit={async (e) => {
                e.preventDefault()
                setError('')
                if (code.trim() === '') return
                if (discountCodes.filter(discountCode => discountCode.code.trim().toUpperCase() === code.trim().toUpperCase()).length > 0) {
                    setStatus(s.error)
                    setError('Ce code a déjà été utilisé.')
                    return
                }
                setStatus(s.loading)
                let discountCode = null
                try {
                    discountCode = await getDiscountCode(aroeven, supplier, prestation, code.toUpperCase())
                } catch (error) {
                    console.log(error)
                    setStatus(s.error)
                    setError('Ce code n\'est pas valide')
                    return
                }
                if (discountCode === null) {
                    setStatus(s.error)
                    setError('Ce code n\'est pas valide')
                    return
                }
                apply(discountCode)
                setError('')
                setCode('')
                setStatus(s.idle)                
            }}>
            <div className="form-input input-group">
                <input type="text" className="form-control" value={code} onChange={(e) => setCode(e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase())} />
                <label className="lh-1 text-light-1">
                    Code de réduction                    
                </label>
                <button className="btn btn btn-primary" type="submit" disabled={status === s.loading}>{status === s.loading ? 'En cours...' : 'Appliquer'}</button>
            </div>
            {status === s.error && error &&
                <span className="f-requis">
                    {error}
                </span>
            }
        </form >
        </>
    )

}